/**
 * Utility per gestire i festivi italiani
 */

function getEasterSunday(year: number): Date {
  // Anonymous Gregorian algorithm
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
}

/**
 * Verifica se una data e un festivo italiano (weekend o festivo)
 * @param date Data da verificare
 * @returns true se e un festivo, false altrimenti
 */
export function isItalianHoliday(date: Date): boolean {
  // Weekend
  const weekday = date.getDay();
  if (weekday === 0 || weekday === 6) {
    return true;
  }

  const month = date.getMonth() + 1; // getMonth() restituisce 0-11
  const day = date.getDate();

  // Pasquetta (Lunedi dell'Angelo): lunedi successivo alla Pasqua
  const easterMonday = getEasterSunday(date.getFullYear());
  easterMonday.setDate(easterMonday.getDate() + 1);
  if (month === easterMonday.getMonth() + 1 && day === easterMonday.getDate()) {
    return true;
  }

  // Festivi fissi italiani
  switch (month) {
    case 1: // Gennaio
      if (day === 1) return true; // Capodanno
      if (day === 6) return true; // Epifania
      break;
    case 4: // Aprile
      if (day === 25) return true; // Liberazione
      break;
    case 5: // Maggio
      if (day === 1) return true; // Festa del Lavoro
      break;
    case 6: // Giugno
      if (day === 2) return true; // Festa della Repubblica
      break;
    case 8: // Agosto
      if (day === 15) return true; // Ferragosto
      break;
    case 11: // Novembre
      if (day === 1) return true; // Ognissanti
      break;
    case 12: // Dicembre
      if (day === 8) return true; // Immacolata Concezione
      if (day === 25) return true; // Natale
      if (day === 26) return true; // Santo Stefano
      break;
  }

  return false;
}

/**
 * Verifica se una data e un giorno lavorativo
 * @param date Data da verificare
 * @returns true se e un giorno lavorativo, false altrimenti
 */
export function isWorkingDay(date: Date): boolean {
  return !isItalianHoliday(date);
}

/**
 * Verifica se un giorno specifico e festivo (versione con parametri separati per compatibilita)
 * @param day Giorno del mese (1-31)
 * @param month Mese (1-12)
 * @param year Anno
 * @returns true se e un festivo, false altrimenti
 */
export function isHoliday(day: number, month: number, year: number): boolean {
  const date = new Date(year, month - 1, day);
  return isItalianHoliday(date);
}
